<script>
import ModuleTitle from '../common/ModuleTitle.vue'

import { getShadowColor } from '@/utils/modules/getStyles'
import { changeSeconds } from '@/utils/common'

export default {
  name: 'Comp16',
  components: { ModuleTitle },
  props: {
    moduleOption: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      path: this.$route.path
    }
  },
  methods: { getShadowColor, changeSeconds }
}
</script>

<template>
  <div class="modules-id-16">
    <module-title :title="moduleOption.title" margin-bottom="24" />
    <div class="comp-transverse-3 modules-id-16-content pointer">
      <div
        v-for="v in moduleOption.list.slice(0, 4)"
        :key="`modules-16-${v.id}`"
        :style="{boxShadow: `0 3px 10px 0 ${getShadowColor(path)}`}"
        class="item"
      >
        <el-image :src="v.photo | imgPath" class="item-movie-cover" alt="movie" fit="cover" />
        <div class="item-right">
          <div class="title-content">
            <p class="item-title h-line-1">{{ v.headline || '' }}</p>
            <p class="item-time">时长: {{ changeSeconds(v.time, 'str') }}</p>
          </div>
          <p class="item-intro h-line-3">{{ v.memo || '' }}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.modules-id-16-content {
  height: 100%;
  display: flex;
  flex-direction: column;
  row-gap: 20px;
  align-items: flex-start;
}
.item {
  width: 450px;
  height: 150px;
  border-radius: 5px;
  background-color: #fff;
  padding: 6px;
  box-sizing: border-box;
  display: flex;
}
.item-movie-cover {
  width: 105px;
  height: 138px;
  border-radius: 5px;
}
.item-right {
  width: 310px;
  height: 138px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin-left: 16px;
  .title-content {
    width: 310px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    .item-title {
      width: 200px;
      font-size: 17px;
      font-weight: 800;
      color: #040000;
    }
    .item-time {
      font-size: 15px;
      font-weight: 600;
      color: var(--grey-text-color);
    }
  }
  .item-intro {
    width: 310px;
    margin-top: 25px;
    font-size: 15px;
    font-weight: 600;
    color: #000;
    line-height: 25px;
    text-indent: 2em;
  }
}
</style>
